import { useState } from "react";
import { PhoneInput } from "react-international-phone";
import "./CustomePhoneInput.scss";

interface PhoneInputProps {
  placeHolder?: string;
  value: string;
  handlePhoneNumberChange: (value: any, countryData: any) => void;
}

const MobileInputCompo = ({
  placeHolder,
  value,
  handlePhoneNumberChange,
}: PhoneInputProps) => {
  const [phone1, setPhone1] = useState(value);
  const containsCharacter = (str: string) => /[a-zA-Z]/.test(str);
  return (
    <div className="h-100">
      <PhoneInput
        inputStyle={{
          width: "100%",
          fontSize: "14px",
          height: "43px",
        }}
        className="custom-phone-input"
        countrySelectorStyleProps={{
          buttonClassName: "country-selector-btn"
        }}
        defaultCountry="in"
        value={phone1}
        forceDialCode
        onChange={(phone: any, country: any) => {
          if (containsCharacter(phone)) {
            return;
          }
          setPhone1(phone);
          let countryData = country?.country;

          handlePhoneNumberChange(phone, countryData);
        }}
      />
    </div>
  );
};
export default MobileInputCompo;
